/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getBottomBannerConfig } from "selectors/bottomBoardSelectors";
import { getInitialContext, registerEventHandler } from "utils/BottomBannerDropinUtils";
import BottomBannerDropinWrapper from "components/bottomBoard/BottomBannerDropinWrapper";

const getBottomBannerDropinId = stores => {
  const { dropinId: bottomBannerDropinId } = getBottomBannerConfig(stores) || {};
  return bottomBannerDropinId;
};

const mapStoreToProps = stores => ({
  dropinId: getBottomBannerDropinId(stores),
  registerEventHandler: config => registerEventHandler(config, stores),
  getInitialContext: () => getInitialContext(stores)
});

const BottomBannerDropinWrapperContainer = inject(mapStoreToProps)(BottomBannerDropinWrapper);

export default BottomBannerDropinWrapperContainer;
